export const ACTIVE_CLASS = 'is-active';
export const ENTERING_CLASS = 'is-entering';
export const EXITING_CLASS = 'is-exiting';
export const ANIMATING_CLASS = 'is-animating';
export const ACCORDION_ROW_ACTIVE_CLASS = 'content__row--accordion-active';
export const ACCORDION_WRAP_ACTIVE_CLASS = 'accordion__content-wrap--active';
